import Vue from "vue";
import messageService from "./../../../services/message";
import rentalService from "./../../../services/rental";
import messageTemplateService from "./../../../services/message-template";
import ta from "time-ago";
import moment from "moment";
import _ from "lodash";
import mixin from "../../../mixins/mixin";
import accountService from "../../../services/account";
import DatePicker from "vue2-datepicker";
import automationService from "../../../services/automation";
import shortCodes from "../../../mixins/shortCodes";
import bookingService from "./../../../services/booking";
import getNew from "../../../services/message/get-new";

export default {
  data() {
    return {
      rentals: [],
      loading: true,
      message: {
        type: "mail",
        text: "",
      },
      messagesLoading: true,
      threads: [],
      threadDetail: {
        guest: {},
        checking: "",
        rental: {},
        channel: {},
        phone: "",
      },
      activeThread: -1,
      selectedThreadSms: 0,
      searchText: null,
      currentPage: 0,
      limit: 10,
      lastPage: "",
      user: {
        is_team_member: "",
        rights: {},
        currency: {},
      },
      reminderTime: "",
      customDateSelected: "",
      beforeOrAfterDays: 1,
      setTimeOut: false,
      templateDetails: false,
      newTemplateOpen: false,
      messageTemplate: {
        name: "",
        body: "",
        type: "",
      },
      defaultMessageTemplate: {
        name: "",
        body: "",
        type: "",
      },
      saveTemplateDisabled: false,
      userTemplates: [],
      notifications: [],
      showTemplateType: "notification",
      isTemplateDeleting: false,
      isTemplateEditing: false,
      airbnbAccountToken: "",
      sortByValue: "message",
      offsetFuture: 0,
      offsetPast: -1, // to increase it and set 0 during first call for past bookings
      isLastPage: false,
      shortCodeName: "",
      selectedShortCode: "",
      textMessage: "",
      shortCodes: [],
      showBookingPrices: false,
      showBookingActions: false,
      sendButtonDisable: true,
      langs: ["fr", "en", "pt", "es"],
      templateLoading: false,
      bookings: [],
      activeBooking: [],
      messages: [],
      afterSent: false,
      totalBookings: 0,
      offset: 0,
    };
  },
  components: {
    VLayout: require("layouts/default/default.vue"),
    VPanel: require("components/panel/panel.vue"),
    Redactor: require("components/redactor/redactor.vue"),
    VLoading: require("components/loading/loading.vue"),
    DatePicker,
    VShortCodeListModal: require("components/short-codes/ShortCodeListModal"),
    VImportNewAirbnbRentals: require("../../account/settings/modals/ImportNewAirbnbRentals"),
  },
  mixins: [mixin, shortCodes],
  watch: {
    messages: {
      handler: function (val) {
        this.resetMessageScroll();
      },
    },
    bookings: {
      handler: function (val) {
        if (!this.afterSent) {
          this.activeBooking = 0;
        }
        this.afterSent = false;
        this.bookings[this.activeBooking].messages.map((message) => {
          message.text = this.createTextLinks(message.text);
        });
        this.messages = this.bookings[this.activeBooking].messages;
      },
    },
    activeBooking: {
      handler: function (val) {
        this.messages = this.bookings[val].messages;

        if (this.bookings[val].unread) {
          this.mark_as_read_messages(this.bookings[val].id);
        }

        Vue.router.push({
          name: "messages.index",
          params: {
            id: this.bookings[val].id,
          },
        });

        this.resetMessageScroll();
      },
    },
    message: {
      handler: function (val) {
        this.sendButtonDisable = val.text.trim() !== "" ? false : true;
        if (val.type != "reminder") {
          this.reminderTime = "";
          this.customDateSelected = "";
        }
      },
      deep: true,
    },
    searchText: {
      handler: function (val) {
        if (val && val.length > 2) {
          getNew(this, this.sortByValue, this.limit, 0, val);
        }
      },
    },
    beforeOrAfterDays: {
      handler: function (val) {
        let vm = this;
        let now = vm.calculateTimeFromNow(vm.reminderTime);
        vm.message.text = "//remind " + now + " ";
        vm.$refs["message-textarea"].focus();
      },
    },
  },
  async mounted() {
    let vm = this;
    $(".panel-overlay").click(function () {
      vm.closeTemplates();
    });
    // await this.get_rentals();
    vm.loading = true;

    await getNew(vm, vm.sortByValue, vm.limit, 0, this.searchText);

    const waitForMessages = setInterval(function () {
      if (!vm.messagesLoading) {
        clearInterval(waitForMessages);
        vm.resetMessageScroll();
      }
    }, 500);

    // await vm.getAccountRights();
    await vm.getTemplates();
    await automationService.getCustomShortCodes(vm);
    vm.messagesLoading = false;
    vm.loading = false;
  },
  methods: {
    resetMessageScroll() {
      var container = this.$refs.messages;
      const waitForContainer = setInterval(function () {
        if (container.scrollHeight > 0) {
          clearInterval(waitForContainer);
          container.scrollTop = container.scrollHeight;
        }
      }, 300);
    },
    async setActiveBooking(index) {
      let vm = this;
      vm.activeBooking = index;
    },
    async get_rentals() {
      let vm = this;
      vm.loading = true;
      await rentalService.getRentalsList(vm, true);
    },
    show_onboarding() {
      $(".onBoarding-modal").addClass("show");
      $("body").addClass("modal-open");
      $("body").append('<div class="modal-backdrop fade show"></div>');
      $(".modal-content").css({ display: "block" });
      $(".navbar").css({ "z-index": "0" });
    },
    date(date) {
      moment.locale("fr", {
        months: this.$t("months"),
        weekdaysShort: this.$t("medWeekDays"),
        monthsShort: this.$t("shortMonths"),
      });
      return moment(date).format("ddd DD MMM");
    },
    date_detail(date) {
      return moment(date).format("ddd DD MMM. YYYY - HH:mm:ss");
    },
    add(date, checkout) {
      moment.locale("fr", {
        months: this.$t("months"),
        weekdaysShort: this.$t("medWeekDays"),
        monthsShort: this.$t("shortMonths"),
      });

      let days = this.$options.filters.calculateNight(date, checkout);
      return moment(date).add(days, "days").format("ddd DD MMM");
    },
    getStatus(checkin, checkout) {
      if (this.threadDetail.status != "accepted") return "Inquiry";
      var curdate = moment(new Date(), "YYYY-MM-DD").startOf("day");
      var checkin = moment(new Date(checkin), "YYYY-MM-DD").startOf("days");
      var checkout = moment(new Date(checkin), "YYYY-MM-DD").startOf("days");
      if (curdate.diff(checkin, "days") < 0) return "Booked";
      else if (
        curdate.diff(checkin, "days") >= 0 &&
        curdate.diff(checkout, "days") <= 0
      )
        return "Checked in";
      else if (curdate.diff(checkout, "days") > 0) return "Checked out";
    },
    async getThreads(
      search = false,
      isFuture = null,
      offsetFuture = null,
      offsetPast = null,
      bookingId = null,
      activeNum = 0
    ) {
      if (search) {
        if (this.searchText.replace(" ", "").length == 0) {
          this.offsetFuture = 0;
          this.offsetPast = -1;
          await messageService.getThreads(
            this,
            this.limit,
            this.currentPage,
            "",
            true,
            this.offsetFuture,
            this.offsetPast,
            bookingId,
            activeNum
          );
          return;
        } else {
          this.currentPage = 0;
        }
      }
      await messageService.getThreads(
        this,
        this.limit,
        this.currentPage,
        this.searchText,
        isFuture,
        offsetFuture,
        offsetPast,
        bookingId,
        activeNum
      );
    },
    ago(time) {
      return ta.ago(time);
    },
    async onSend(account, bookingID) {
      let vm = this;

      vm.afterSent = true;

      vm.messagesLoading = true;
      if (!vm.message || vm.message == "") {
        return toastr.error("Input Message");
      }
      await vm.sendMessage(bookingID);

      vm.messagesLoading = false;
    },
    async sendMessage(bookingID) {
      let text = this.message.text;
      this.message.booking_id = bookingID;
      this.message.from = "user";
      this.message.guest_id = this.bookings[this.activeBooking].guest.id;

      if (this.message.type == "sms") {
        //TODO Create Service for Send sms
        return await Vue.$http
          .post("/sms/send", this.message)
          .then((response) => {
            if (response.status === 200) {
              this.success = response.data.msg;
              toastr.success(response.data.msg);
              this.message.text = "";
              this.bookings[this.activeBooking].messages.push(
                response.data.message
              );
              this.resetMessageScroll();
            }
          })
          .catch((error) => {
            if (error.response) {
              if (
                error.response.data &&
                error.response.data.type &&
                error.response.data.type == "billing_empty"
              ) {
                toastr.error(this.$t("messages.index.billing_empty"));
              } else if (
                error &&
                error.response &&
                error.response.data &&
                error.response.data.msg
              ) {
                this.error = error.response.data.msg;
              }
            }
          });
      } else if (this.message.type == "mail" || this.message.type == "note") {
        let airbnbis = false;
        //TODO Create Service for send email
        await Vue.$http
          .post("/messages", {
            message: this.message,
            token: this.airbnbAccountToken,
          })
          .then((response) => {
            if (response.status === 200) {
              this.success = response.data.msg;
              this.message.text = "";
              this.bookings[this.activeBooking].messages.push(
                response.data.message
              );
              this.resetMessageScroll();
            }
          })
          .catch((error) => {
            if (error && error.response && error.response.data) {
              this.loading = false;
              if (error.response.data.msg) {
                this.error = error.response.data.msg;
              } else {
                this.error = "Your email credentials is wrong!";
              }
              if (error.response.data.authErrors) {
                let authErrors = error.response.data.authErrors;
                for (let error of authErrors) {
                  toastr.error(
                    this.$t(
                      "account.settings.user_platforms_section.airbnb_auth_error"
                    ) +
                      " " +
                      error
                  );
                }
              } else {
                toastr.error(this.error);
              }
            }
          });
        if (airbnbis) {
          await this.getThreads(
            false,
            true,
            this.offsetFuture,
            this.offsetPast,
            this.message.booking_id,
            this.activeThread
          );
        }
      } else if (this.message.type == "reminder") {
        this.message.reminder_id = this.reminderTime;
        if (this.message.reminder_id == 6) {
          this.message.reminder_custom_time = this.customDateSelected;
        } else if (
          this.message.reminder_id == 7 ||
          this.message.reminder_id == 8 ||
          this.message.reminder_id == 9 ||
          this.message.reminder_id == 10
        ) {
          this.message.after_or_before_days = this.beforeOrAfterDays;
        }
        await messageService.saveReminder(this, this.message);
      } else if (this.message.type == "whatsApp") {
        let phone = this.bookings[this.activeBooking].guest.phone.replace(
          /\s+/g,
          ""
        );
        phone = phone.replace(/[^\w +]/g, "");
        const text = encodeURIComponent(this.message.text);
        window.open(`https://wa.me/${phone}?text=${text}`, "_blank");
      }
    },
    gotoBookingDetails() {
      let vm = this;
      Vue.router.push({
        name: "bookings.details",
        params: {
          id: vm.bookings[this.activeBooking].id,
        },
      });
    },
    gotoRentalDetails() {
      let vm = this;
      Vue.router.push({
        name: "rentals.detail",
        params: {
          id: vm.threadDetail.rental.id,
        },
      });
    },
    mark_as_read_messages(booking_id) {
      let vm = this;
      //TODO Create Service for Mark sms as read
      Vue.$http
        .get("/sms/mark/as/read?booking_id=" + booking_id)
        .then((response) => {
          if (response.status === 200) {
            vm.bookings[vm.activeBooking].unread = 0;
          }
        })
        .catch((error) => {
          if (error.response) {
            clearInterval(intervall);
            vm.showToasterError(error);
          }
        });
    },
    async prevPage() {
      if (this.offset <= 0 || this.offset < this.limit) {
        return false;
      }

      this.offset = this.offset - this.limit;
      this.loading = true;

      await getNew(
        this,
        this.sortByValue,
        this.limit,
        this.offset,
        this.searchText
      );
      this.loading = false;
    },
    async nextPage() {
      if (
        this.offset >= this.totalBookings ||
        this.totalBookings < this.limit
      ) {
        return false;
      }

      this.offset = this.offset + this.limit;
      this.loading = true;

      await getNew(
        this,
        this.sortByValue,
        this.limit,
        this.offset,
        this.searchText
      );
      this.loading = false;
    },
    async getAccountRights() {
      let vm = this;
      await accountService.getAccountRights(vm, true);
    },
    selectReminderTime(id) {
      let vm = this;
      vm.reminderTime = id;
      vm.message.type = "reminder";
      if (id != 6) {
        var now = vm.calculateTimeFromNow(id);
        vm.message.text = "//remind " + now + " ";
        vm.$refs["message-textarea"].focus();
      } else {
        vm.message.text = "//remind";
        vm.$refs["reminder-picker"].focus();
      }
    },
    calculateTimeFromNow(id) {
      let vm = this;
      var now = moment().format("MMM DD, YYYY");
      switch (id) {
        case 1: {
          now = moment().add(1, "hours").format("DD/MM/YYYY HH:mm");
          break;
        }
        case 2: {
          now = moment().add(2, "hours").format("DD/MM/YYYY HH:mm");
          break;
        }
        case 3: {
          now = moment().add(1, "days").format("DD/MM/YYYY HH:mm");
          break;
        }
        case 4: {
          now = moment().add(2, "days").format("DD/MM/YYYY HH:mm");
          break;
        }
        case 5: {
          now = moment().add(7, "days").format("DD/MM/YYYY HH:mm");
          break;
        }
        case 7: {
          //after checking
          let checking = vm.filteredList[vm.activeThread].checking;
          now = moment(checking)
            .add(vm.beforeOrAfterDays, "days")
            .format("DD/MM/YYYY");
          break;
        }
        case 8: {
          //after checkout
          let checkout = vm.filteredList[vm.activeThread].checkout;
          now = moment(checkout)
            .add(vm.beforeOrAfterDays, "days")
            .format("DD/MM/YYYY");
          break;
        }
        case 9: {
          //before checking
          let checking = vm.filteredList[vm.activeThread].checking;
          now = moment(checking)
            .subtract(vm.beforeOrAfterDays, "days")
            .format("DD/MM/YYYY");
          break;
        }
        case 10: {
          //before checkout
          let checkout = vm.filteredList[vm.activeThread].checkout;
          now = moment(checkout)
            .subtract(vm.beforeOrAfterDays, "days")
            .format("DD/MM/YYYY");
          break;
        }
      }

      return now;
    },
    searchMessages() {
      let vm = this;
      if (vm.setTimeOut) {
        clearTimeout(vm.setTimeOut);
      }
      vm.setTimeOut = setTimeout(
        function () {
          vm.getThreads(true);
        }.bind(vm),
        2000
      );
    },
    showTemplates(editing) {
      if (!editing) {
        this.messageTemplate = { ...this.defaultMessageTemplate };
        this.newTemplateOpen = false;
        this.showTemplateType = "notification";
        this.getBookingTemplates();
        this.templateDetails = true;
      }
      $(".panel-overlay").fadeIn();
      $(".ninja-btn,.panel").addClass("active");
      $(".panel-overlay").fadeIn();
      $(".pannel_sec_second").css({ right: "-350px" });
    },
    closeTemplates() {
      let vm = this;
      if (vm.showTemplateType !== "notification" && vm.isTemplateEditing) {
        toastr.error(vm.$t("message_templates.save_current"));
      } else {
        $(".ninja-btn, .panel").removeClass("active");
        $(".panel-overlay").fadeOut();
        $(".pannel_sec_second").css({ right: "-350px" });
        vm.templateDetails = false;
        vm.isTemplateEditing = false;
        vm.addNewFeldToTemplates("change");
      }
    },
    async createTemplate() {
      let vm = this;
      vm.saveTemplateDisabled = true;
      vm.messageTemplate.type = vm.showTemplateType;
      await messageTemplateService.createTemplate(vm, vm.messageTemplate);
    },
    async getTemplates() {
      let vm = this;
      await messageTemplateService.getTemplates(vm);
    },
    addNewFeldToTemplates(type) {
      let vm = this;
      let defLength = vm.notifications.length;
      let tempLength = vm.userTemplates.length;

      if (defLength > 0) {
        for (var i = 0; i < defLength; i++) {
          if (type == "set") {
            Vue.set(vm.notifications[i], "body_open", false);
          } else {
            vm.notifications[i].body_open = false;
          }
        }
      }

      if (tempLength > 0) {
        for (var j = 0; j < tempLength; j++) {
          if (type == "set") {
            Vue.set(vm.userTemplates[j], "body_open", false);
          } else {
            vm.userTemplates[j].body_open = false;
          }
        }
      }
    },
    openBody(index, type, event) {
      if (event.target.tagName == "BUTTON") {
        return;
      }
      switch (type) {
        case "notification":
          let defaultBefore = this.notifications[index].body_open;
          !defaultBefore && this.addNewFeldToTemplates("change");
          this.notifications[index].body_open = !defaultBefore;
          break;
        case "user": {
          let userBefore = this.userTemplates[index].body_open;
          !userBefore && this.addNewFeldToTemplates("change");
          this.userTemplates[index].body_open = !userBefore;
          break;
        }
      }
      this.$forceUpdate();
    },
    async insertBody(index, type, id) {
      let text = "";
      if (type === "notification") {
        text = this.notifications[index].message
          .replace(/<p><br?\/?><\/p>/gi, "\n") // replace all <p><br></p> and <p><br/></p> to \n
          .replace(/<\/p>/gi, "\n") // replace all </p> to \n
          .replace(/(<([^>]+)>)/gi, "") // remove all html tags
          .replace(/&nbsp;/g, " "); // replace all &nbsp; to space
      } else {
        text = this.userTemplates[index].body;
      }
      const content = {
        id,
        text,
      };

      await messageService.getReplacedShortCodesText(this, content);
      const { text: objText = "" } = this.message;
      this.message.text = objText + this.textMessage;
      this.$refs["message-textarea"].focus();
      this.closeTemplates();
    },
    editTemplate(id, index, type, event) {
      let vm = this;
      if (vm.isTemplateEditing) {
        toastr.error(vm.$t("message_templates.save_current"));
        event.stopPropagation();
        return false;
      }
      if (type === "default") {
        vm.messageTemplate = vm.defaultTemplates[index];
        vm.defaultTemplates.splice(index, 1);
      } else {
        vm.messageTemplate = vm.userTemplates[index];
        vm.userTemplates.splice(index, 1);
      }
      vm.isTemplateEditing = true;
      vm.newTemplateOpen = true;
      event.stopPropagation();
    },
    deleteTemplate(id, index, type, event) {
      let vm = this;
      vm.isTemplateDeleting = true;
      messageTemplateService.deleteTemplate(vm, index, type, id);
      event.stopPropagation();
    },
    async updateTemplate() {
      let vm = this;
      vm.saveTemplateDisabled = true;
      await messageTemplateService.editTemplate(vm, vm.messageTemplate);
    },
    async getAirbnbMessageForSpecifiedBooking(index, id) {
      let vm = this;
      await messageService.getAirbnbMessageForSpecifiedBooking(vm, index, id);
    },
    async sortBy() {
      await getNew(this, this.sortByValue, this.limit, 0, this.searchText);
    },
    openShortcodeListModal(name) {
      if (this.langs.indexOf(localStorage.getItem("lang")) === -1) {
        this.shortCodeName = "name_en";
      } else {
        this.shortCodeName = `name_${localStorage.getItem("lang")}`;
      }
      this.openModal(name);
    },
    closeAndOpenModals() {
      this.closeModal("#shortcode-list-modal");
      this.showTemplates(true);
    },
    insertShortcodeToText() {
      let vm = this;
      let cursorPosition = $("#message-template-body").prop("selectionStart");
      vm.messageTemplate.body = `${vm.messageTemplate.body.substring(
        0,
        cursorPosition
      )}${vm.selectedShortCode}${vm.messageTemplate.body.substring(
        cursorPosition
      )}`;
      vm.closeAndOpenModals();
    },
    changeSelectedShortCode(newSelectedShortCode) {
      this.selectedShortCode = newSelectedShortCode;
    },
    openImportNewRentalsModal() {
      this.$refs.airbnbImportModal.openImportNewRentalsModal();
    },
    async getBookingTemplates() {
      if (this.notifications.length === 0) {
        this.templateLoading = true;
      }
      await bookingService.getBookingTemplates(this, this.$route.params.id);
      this.templateLoading = false;
    },
    cancelNewTemplateAdd() {
      this.newTemplateOpen = false;
      this.messageTemplate = { ...this.defaultMessageTemplate };
    },
  },
  computed: {
    filteredList: function () {
      return this.threads;
    },
    labelName() {
      if (
        this.threads &&
        this.activeThread !== false &&
        this.bookings[this.activeBooking]
      ) {
        if (this.bookings[this.activeBooking]["message_thread_id"]) {
          return "AIRBNB";
        } else if (this.bookings[this.activeBooking]["booking_com_res_id"]) {
          return "Booking.com";
        }
      }

      return this.$t("booking.detail.email");
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/messages/index/index.js